var $f906d8c9d57a8ac7$exports = {};
$f906d8c9d57a8ac7$exports = {
  "collapse": "Strni",
  "expand": "Raz\u0161iri"
};
export { $f906d8c9d57a8ac7$exports as default };